<div class="page-container unit-profile-container container">
  <app-utility-toolbar />
  <h1 class="header col-12">Unit Profile</h1>

  <div>
    <app-toolbar
      class="row w-100 mx-auto px-4"
      [showAllApps]="true"
      (unitAppSelected)="getUnitProfile($event)"
      (unitAppReport)="getUnitProfileReport($event)"
    />
    @if (profileData && !loading) {
      <app-formly
        class="mx-0"
        [context]="tabContext"
        [data]="profileData"
        [triggerSave]="save"
      />
    }
    @if (!profileData) {
      <h2 class="mt-5 text-center w-100">
        Please Select an App and Unit Above
      </h2>
    }
  </div>
</div>
<ngx-loading [show]="loading" />
